import moment from 'moment'
import { formatTime, roundUpDurationFor } from '@/utils/datetimes'

import { isPremium } from '@/utils/kuraemon_plans'

const todayString =() => (formatTime(moment().valueOf(), "YYYY-MM-DD"))

const get = property => (state) => (state[property])

export default {
  namespaced: true,
  state: {
    notificationVars: null,
    /**
     * アカウント毎の、最後のお知らせした日付
     * @type {
     *   {
     *     [accountId: string]: string
     *   }
     * }
     */
    lastNotifiedDates_v1: {},
  },
  getters: {
    notificationVars: get('notificationVars'),
    lastNotifiedDateFor: state => (accountId) => {
      return state.lastNotifiedDates_v1[accountId]
    },
  },
  mutations: {
    setNotificationVars(state, notificationVars){
      state.notificationVars = notificationVars
      if(notificationVars && notificationVars.account_id){
        state.lastNotifiedDates_v1[notificationVars.account_id] = todayString()
        state.lastNotifiedDates_v1 = Object.assign({}, state.lastNotifiedDates_v1, state.lastNotifiedDates_v1)
      }
    },
  },
  actions: {
    async startPremiumExpiringNotifications(context){
      const { account_id } = context.rootGetters['api/result/accountInfo']

      const lastNotifiedDate = context.getters.lastNotifiedDateFor(account_id)
      if(lastNotifiedDate === todayString()){
        // 今日、既に表示している場合は終了(1日1回だけ表示する)
        return
      }

      const result = await context.dispatch("accountPlans/retrieveAccountPlanInfo", { noDisplayLoading: true }, { root: true })
      if(!result) return

      // プラン(次の契約がある場合は次のプラン)の タイプと、期限切れmillis
      const {
        service_contract_type,
        service_contract_expired_at,
        service_contract_enterprise_license_id,
      } = context.rootGetters['api/result/displayPlan']

      if(service_contract_enterprise_license_id){
        // エンタープライズの場合は終了
        return
      }

      if(!isPremium(service_contract_type)){
        // プレミアムでない場合は終了
        return
      }

      // 期限切れまでの期間
      const { duration, unit } = roundUpDurationFor(service_contract_expired_at + 1)
      if(unit === 'months'){
        if(2 < duration){
          // 2ヶ月より前の場合は出さない
          return
        }
      }
      if(unit === 'days'){
        if(duration < 1){
          // 既に期限切れのケース
          throw new Error("expired contract")
        }
      }
      context.commit('setNotificationVars', {
        account_id,
        service_contract_expired_at,
        duration,
        unit,
      })
    },
    resetNotificationVars({ commit }){ 
      commit('setNotificationVars', null)
    },
  },
}
